export default "__VITE_ASSET__43d0d406__"